import type { ReactNode } from 'react';

export interface PageContainerProps {
    children: ReactNode;
    /** False drops the top and bottom padding, for a container inside a band that sets its own. */
    verticalPadding?: boolean;
}

/** The page width and side padding every page shares. */
export function PageContainer({ children, verticalPadding = true }: PageContainerProps) {
    return (
        <div className={`mx-auto max-w-(--breakpoint-2xl) px-4 md:px-6 ${verticalPadding ? 'py-4 md:py-6' : ''}`}>
            {children}
        </div>
    );
}
